import { render, staticRenderFns } from "./ListAddresses.vue?vue&type=template&id=705b187e&scoped=true"
import script from "./ListAddresses.vue?vue&type=script&lang=js"
export * from "./ListAddresses.vue?vue&type=script&lang=js"
import style0 from "./ListAddresses.vue?vue&type=style&index=0&id=705b187e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b187e",
  null
  
)

export default component.exports